import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FiPlus, 
  FiEdit, 
  FiTrash2, 
  FiEye, 
  FiCalendar, 
  FiMapPin, 
  FiUsers, 
  FiClock,
  FiFilter,
  FiSearch
} from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../../services/api';
import './Visitas.css';

const Visitas = ({ tipo }) => {
  // const navigate = useNavigate();
  const [visitas, setVisitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({
    tipo_visita: '',
    status: '',
    data_inicio: '',
    data_fim: '',
    titulo: ''
  });
  const [estatisticas, setEstatisticas] = useState([]);

  const tiposVisita = [
    { value: 'mocidade', label: 'Visita - Mocidade' },
    { value: 'criancas', label: 'Visita - Crianças' },
    { value: 'ajuntamento', label: 'Ajuntamento' },
    { value: 'reuniao_familiar', label: 'Reunião Familiar' },
    { value: 'reuniao_evangelizacao', label: 'Reunião Evangelização' }
  ];

  const statusOptions = [
    { value: 'planejada', label: 'Planejada' },
    { value: 'realizada', label: 'Realizada' },
    { value: 'cancelada', label: 'Cancelada' }
  ];

  const carregarVisitas = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      
      Object.keys(filtros).forEach(key => {
        if (filtros[key]) {
          params.append(key, filtros[key]);
        }
      });

      const response = await api.get(`/visitas?${params.toString()}`);
      setVisitas(response.data);
    } catch (error) {
      console.error('Erro ao carregar visitas:', error);
      toast.error('Erro ao carregar visitas');
    } finally {
      setLoading(false);
    }
  }, [filtros]);

  useEffect(() => {
    carregarEstatisticas();
    carregarVisitas();
  }, [carregarVisitas]);

  useEffect(() => {
    if (tipo) {
      setFiltros(prev => ({ ...prev, tipo_visita: tipo }));
    }
  }, [tipo]);

  const carregarEstatisticas = async () => {
    try {
      const response = await api.get('/visitas/estatisticas');
      setEstatisticas(response.data);
    } catch (error) {
      console.error('Erro ao carregar estatísticas:', error);
    }
  };

  const handleFiltroChange = (campo, valor) => {
    setFiltros(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  const limparFiltros = () => {
    setFiltros({
      tipo_visita: '',
      status: '',
      data_inicio: '',
      data_fim: '',
      titulo: ''
    });
  };

  const excluirVisita = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta visita?')) {
      try {
        await api.delete(`/visitas/${id}`);
        toast.success('Visita excluída com sucesso!');
        carregarVisitas();
        carregarEstatisticas();
      } catch (error) {
        console.error('Erro ao excluir visita:', error);
        toast.error('Erro ao excluir visita');
      }
    }
  };

  const formatarData = (data) => {
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const formatarHora = (hora) => {
    return hora ? hora.substring(0, 5) : '';
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'planejada': { class: 'status-planejada', text: 'Planejada' },
      'realizada': { class: 'status-realizada', text: 'Realizada' },
      'cancelada': { class: 'status-cancelada', text: 'Cancelada' }
    };
    
    const statusInfo = statusMap[status] || { class: 'status-default', text: status };
    return <span className={`status-badge ${statusInfo.class}`}>{statusInfo.text}</span>;
  };

  const getTipoVisitaLabel = (tipo) => {
    const tipoInfo = tiposVisita.find(t => t.value === tipo);
    return tipoInfo ? tipoInfo.label : tipo;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Carregando visitas...</p>
      </div>
    );
  }

  return (
    <div className="visitas-container">
      <div className="page-header">
        <div className="header-content">
          <h1>Gerenciar Visitas</h1>
          <p>Gerencie todas as visitas e atividades da congregação</p>
        </div>
        <div className="header-actions">
          <Link to="/visitas/nova" className="btn btn-primary">
            <FiPlus /> Nova Visita
          </Link>
        </div>
      </div>

      {/* Estatísticas */}
      {estatisticas.length > 0 && (
        <div className="stats-grid">
          {estatisticas.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-header">
                <h3>{stat.categoria}</h3>
              </div>
              <div className="stat-content">
                <div className="stat-item">
                  <span className="stat-label">Total:</span>
                  <span className="stat-value">{stat.total_visitas || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Realizadas:</span>
                  <span className="stat-value">{stat.visitas_realizadas || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Planejadas:</span>
                  <span className="stat-value">{stat.visitas_planejadas || 0}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Filtros */}
      <section className="filters-section">
        <header className="filters-header">
          <h3 className="filters-title">
            <FiFilter className="filters-icon" />
            Filtros
          </h3>
          <button
            type="button"
            onClick={limparFiltros}
            className="filters-clear"
            title="Limpar todos os filtros"
          >
            <span>Limpar</span>
          </button>
        </header>

        <div className="filters-body">
          <div className="filters-search">
            <FiSearch className="filters-search-icon" />
            <input
              type="text"
              placeholder="Buscar por título da visita..."
              value={filtros.titulo}
              onChange={(e) => handleFiltroChange('titulo', e.target.value)}
              className="filters-search-input"
              aria-label="Buscar por título"
            />
          </div>

          <div className="filters-row">
            <div className="filter-group">
              <label htmlFor="filtro-tipo">Tipo</label>
              <select
                id="filtro-tipo"
                value={filtros.tipo_visita}
                onChange={(e) => handleFiltroChange('tipo_visita', e.target.value)}
              >
                <option value="">Todos</option>
                {tiposVisita.map(tipo => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label htmlFor="filtro-status">Status</label>
              <select
                id="filtro-status"
                value={filtros.status}
                onChange={(e) => handleFiltroChange('status', e.target.value)}
              >
                <option value="">Todos</option>
                {statusOptions.map(status => (
                  <option key={status.value} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label htmlFor="filtro-data-inicio">De</label>
              <input
                id="filtro-data-inicio"
                type="date"
                value={filtros.data_inicio}
                onChange={(e) => handleFiltroChange('data_inicio', e.target.value)}
                aria-label="Data início"
              />
            </div>

            <div className="filter-group">
              <label htmlFor="filtro-data-fim">Até</label>
              <input
                id="filtro-data-fim"
                type="date"
                value={filtros.data_fim}
                onChange={(e) => handleFiltroChange('data_fim', e.target.value)}
                aria-label="Data fim"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Lista de Visitas */}
      <div className="visitas-list">
        {visitas.length === 0 ? (
          <div className="empty-state">
            <FiCalendar size={48} />
            <h3>Nenhuma visita encontrada</h3>
            <p>Não há visitas cadastradas com os filtros selecionados.</p>
            <Link to="/visitas/nova" className="btn btn-primary">
              <FiPlus /> Criar primeira visita
            </Link>
          </div>
        ) : (
          <div className="visitas-grid">
            {visitas.map(visita => (
              <div key={visita.id} className="visita-card">
                <div className="visita-header">
                  <div className="visita-tipo">
                    {getTipoVisitaLabel(visita.tipo_visita)}
                  </div>
                  {getStatusBadge(visita.status)}
                </div>
                
                <div className="visita-content">
                  <h3 className="visita-titulo">{visita.titulo}</h3>
                  
                  <div className="visita-info">
                    <div className="info-item">
                      <FiCalendar />
                      <span>{formatarData(visita.data_visita)}</span>
                    </div>
                    
                    <div className="info-item">
                      <FiClock />
                      <span>
                        {formatarHora(visita.hora_inicio)}
                        {visita.hora_fim && ` - ${formatarHora(visita.hora_fim)}`}
                      </span>
                    </div>
                    
                    <div className="info-item">
                      <FiMapPin />
                      <span>{visita.local_visita}</span>
                    </div>
                    
                    <div className="info-item">
                      <FiUsers />
                      <span>{visita.total_participantes || 0} participantes</span>
                    </div>
                  </div>
                  
                  {visita.responsavel_nome && (
                    <div className="visita-responsavel">
                      <strong>Responsável:</strong> {visita.responsavel_nome}
                    </div>
                  )}
                </div>
                
                <div className="visita-actions">
                  <Link 
                    to={`/visitas/${visita.id}`} 
                    className="btn btn-secondary btn-sm"
                    title="Ver detalhes"
                  >
                    <FiEye />
                  </Link>
                  
                  <Link 
                    to={`/visitas/editar/${visita.id}`} 
                    className="btn btn-primary btn-sm"
                    title="Editar"
                  >
                    <FiEdit />
                  </Link>
                  
                  <button 
                    onClick={() => excluirVisita(visita.id)}
                    className="btn btn-danger btn-sm"
                    title="Excluir"
                  >
                    <FiTrash2 />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Visitas;